// Shared formatting for App\Models\ExternalUserProfile fields across every
// public member card/profile (Editorial Board, ECR, Advisory Board,
// Leadership) — kept in one place so the "one line per field" composition
// rule only has to be decided once (department is otherwise unused
// anywhere in the frontend today).
//
// Purely institutional: no job-title line. The person-level `job_title` was
// removed on 2026-10-02 — a person's role is a group-scoped Position in this
// system, which reaches the page as the hero headline
// (PublicRoleProfileResolver::headline()). Mirrors
// App\Support\RoleProfiles\AffiliationFormatter::fromProfile(); keep the two
// in step if the order ever changes.
export function affiliationDetailLines(profile, { location = true } = {}) {
    if (!profile) return [];
    const org = profile.university || profile.affiliation || null;
    return [profile.department, org, ...(location ? [profile.city, profile.country] : [])].filter(Boolean);
}

export function memberAvatarUrl(member) {
    return member?.profile?.avatar_path || null;
}
